"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomString = void 0;

var randomString = function randomString() {
  return 'random';
}; // TODO: Add random string


exports.randomString = randomString;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9oZWxwZXJzL3JhbmRvbS50cyJdLCJuYW1lcyI6WyJyYW5kb21TdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBTyxJQUFNQSxZQUFZLEdBQUcsU0FBZkEsWUFBZTtBQUFBLFNBQU0sUUFBTjtBQUFBLENBQXJCLEMsQ0FBcUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgcmFuZG9tU3RyaW5nID0gKCkgPT4gJ3JhbmRvbSc7IC8vIFRPRE86IEFkZCByYW5kb20gc3RyaW5nXG4iXX0=